import { rowsWithDays, revenueFields, expenseFields } from "./Constants";

export const getPnlRowsStyling = (category: string) => {
  if (rowsWithDays.includes(category)) return "Default";
  if (revenueFields.includes(category)) return "Green";
  if (expenseFields.includes(category)) return "Red";
  return "";
};

export const toSnakeCase = (input: string) => input.split(" ").join("_");
export const parseNumber = (val: string) => parseFloat(val.replace(/[^0-9.-]/g, "") || "0");

export function formatNumberWithDots(input: number | null): string {
  if (input === null || isNaN(input)) return "-";
  const formatted = Math.round(Math.abs(input)).toLocaleString("en-US");
  return input < 0 ? `(${formatted}) $` : `${formatted} $`;
}

export function formatDaysWithDots(input: number | null): string {
  if (input === null || isNaN(input)) return "-";
  const rounded = Math.round(Math.abs(input) * 100) / 100;
  const formatted = rounded.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return input < 0 ? `(${formatted})` : `${formatted}`;
}

export const formatCurrency = (num: number): string => {
  const formatted = new Intl.NumberFormat("en-US").format(Math.abs(num));
  return num < 0 ? `(${formatted}) $` : `${formatted} $`;
};

/**
 * Calculate raw impact for a single row before formatting.
 * - If unit is "USD", the quantity is treated as the impact (rate is ignored).
 * - Otherwise: impact = rate * quantity.
 * - Returns "" when inputs are empty/invalid so caller can decide how to handle blank cells.
 */
export const calculateImpactRaw = (unit: string, rate: string, quantity: string): string => {
  const q = parseNumber(quantity);
  const r = parseNumber(rate);

  // No quantity -> no impact
  if (!quantity?.trim() || isNaN(q)) return "";

  // USD rows: quantity is already in dollars
  if (unit === "USD") return q.toString();

  // Non-USD rows need a valid rate
  if (!rate?.trim() || isNaN(r)) return "";

  return (r * q).toString();
};
